export default [ "pl", "en", "ru", "ua" ];